<template>
  <div v-show="!noRecords">
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
        <ul v-show='validationErrors'>
          <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
        </ul>
      </div>
      <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
        {{success}}
      </div>
      <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
        <label>النوع</label>
        <select @change='fillReceiptItems()' style="padding: 0px" class="form-control"  v-model="record.type_id">
          <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">
            {{item.name}}
          </option>
        </select>
      </div>
      <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
        <label>حالة الاتصال:</label>
        <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
          <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
        <label>الاجراء:</label>
        <select class="form-control" style="padding: 0px" v-model="record.call_action_id">
          <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 0px;'>
        <tbDate :mytitle='DateTitle' :today='today' v-model= 'date' ></tbDate>
      </div>
      <div class='col-lg-8 col-md-8' style='padding:0px'>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>ملاحظات الاتصال:</label>
          <input  @keyup='mirrorNotes()' class="form-control" v-model="record.callNotes" name='notes' type='text'>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>ملاحظات الفنى:</label>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-9 col-md-9 col-sm-9' style='padding: 10px 0px 10px 0px;'>
          <label >العرض:</label>
          <div class="col-lg-12 col-sm-12 form-group input-group"  style='padding: 0px;margin:0px'>
            <span class="input-group-btn">
              <button @click="addToArrReceiptOffers()" class="btn btn-default" type="button"><i class="fa fa-plus" style="color:green"></i>
              </button>
            </span>
            <select class="form-control" style="padding: 0px" v-model="offer_id">
              <option v-for="item in offers" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.offer_name}}
              </option>
            </select>
          </div>
        </div>
        <div class='col-lg-3 col-md-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>النوع</label>
          <select class="form-control" style="padding: 0px" v-model="offer_type">
            <option value='1'>كاش</option>
            <option value='0'>تقسيط</option>
          </select>
        </div>
        <div class='col-lg-9 col-md-9 col-sm-9' style='padding: 0px 0px 0px 0px;'>
          <label >أصناف خارج العرض:</label>
          <div class="col-lg-12 col-sm-12 form-group input-group"  style='padding: 0px;margin:0px'>
            <span class="input-group-btn">
              <button @click="addToArrReceiptItems()" class="btn btn-default" type="button"><i class="fa fa-plus" style="color:green"></i>
              </button>
            </span>
            <input ref="maintenanceItems" v-on:keypress="offer_foucs($event)" v-model='offer' class='form-control' type='text'>
          </div>
        </div>
        <div class='col-lg-3 col-md-3 col-sm-3' style='padding: 0px 0px 0px 10px;'>
          <label>النوع</label>
          <select ref="price_type" style="padding: 0px" class="form-control" v-model="itemsPriceType">
            <option v-for="item in price_types" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>رصيد سابق:</label>
          <input  @keypress="isLocked($event)" @keyup='fillReceiptItems()' v-model='record.balance' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>م صيانة:</label>
          <input  @keypress="isNumber($event)" @keyup='fillReceiptItems()' v-model='record.maintenance_expenses' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>المطلوب:</label>
          <input  @keypress="isLocked($event)" @keyup='fillReceiptItems()' v-model='record.required' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>المدفوع:</label>
          <input  @keypress="isNumber($event)" @keyup='fillReceiptItems()' v-model='record.paid' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>المدفوع:</label>
          {{record.amount_str}}
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>الباقى:</label>
          {{record.rest_str}}
        </div>
      </div>
      <div class='col-lg-4 col-md-4' style='padding:0px'>
        <div class="row" style="padding: 15px 18px 0px 18px;">
          <table width='100%' class='table table-striped table-bordered table-hover' >
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'></th>
                <th style='padding:2px;text-align: center'>البيــــان</th>
                <th style='padding:2px;text-align: center'>التسعير</th>
                <th style='padding:2px;text-align: center'>السعر</th>
              </tr>
            </thead>
            <tbody>
              <tr class='odd gradeX' v-for='(record) in receiptItems' :key='record.id'>
                <td style='padding:2px;text-align: center'><a @click='removeItem(record)' v-show="record.type < 2" style="padding: 0px" class="btn btn-social-icon btn-bitbucket"><i class="fa fa-times" style="color:red"></i></a></td>
                <td style='padding:2px;text-align: center'>{{record.label}}</td>
                <td style='padding:2px;text-align: center'>{{record.priceType}}</td>
                <td style='padding:2px;text-align: center'>{{record.price}}</td>
              </tr>
            </tbody>
          </table>
          <table width='100%' class='table table-bordered '>
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>الصنف</th>
                <th style='padding:2px;text-align: center'>التاريخ الافتراضى</th>
              </tr>
            </thead>
            <tbody>
              <tr v-on:click="changeMaintenanAction(record.id)" :class="{highlight :record.action}" class='odd gradeX' v-for='(record) in maintenancRecords' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.item}}</td>
                <td style='padding:2px;text-align: center'>{{record.default_date}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if='!successShow' class='col-lg-12 col-sm-12' style='text-align:center;padding:10px'>
        <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
        <button  @click='saveData()'  style="width: 100px" type='button' class='btn btn-success'>إصدار</button>
        <button  @click='offerRejected()'  style="width: 100px" type='button' class='btn btn-danger'>رفض العرض</button>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #00E40E;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import tafqeet from '@/./assets/Tafqeet.js'
export default {
  components: {
    tbDate
  },
  name: 'CreateDailyReceipts',
  data () {
    return {
      arrReceiptOffers: [],
      arrReceiptItems: [],
      types: [
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      price_types: [
        {id: 1, name: 'كاش'},
        {id: 2, name: 'قسط'},
        {id: 3, name: 'مستعمل'},
        {id: 4, name: 'ضمان'},
        {id: 5, name: 'هدية'},
        {id: 0, name: 'عرض سابق'}
      ],
      offer_type: 0,
      price1: null,
      price2: null,
      itemsPriceType: 1,
      maintenancRecords: '',
      itemsPriceTypeStr: 'كاش',
      price_type: 0,
      actions: {},
      callStatus: {},
      today: true,
      receiptDate: '',
      title: '',
      DateTitle: 'التاريخ',
      validationErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: 0,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isContractOffersLoading: false,
      branches: {},
      type: 0,
      contract_offer_id: 0,
      uid: '',
      dateTo: '',
      date: '',
      noRecords: false,
      isInLimit: false,
      offer: '',
      items: [],
      receiptItems: []
    }
  },
  props: {
    callMethod: ''
  },
  methods: {
    tabSelected (id, fromDate, toDate, type, offerID, isInLimit, offers, items) {
      this.arrReceiptOffers = []
      this.arrReceiptItems = []
      this.offers = offers
      this.items = items
      this.record = null
      this.errorShow = false
      this.maintenancRecords = null
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.offer = ''
      this.price1 = 0
      this.price2 = 0
      this.GetCallData()
      this.uid = id
      this.offer_id = offerID
      this.contract_offer_id = offerID
      this.isInLimit = isInLimit
      // -----------------------------------------------------
      this.record = {}
      this.type = type
      this.getData(id, fromDate, toDate, type)
    },
    // ========================================================
    GetCallData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-customer-call-logs', {
        token: localStorage.getItem('token'),
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingData = false
          this.actions = res.data.Actions
          this.callStatus = res.data.Status
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ========================================================
    addToArrReceiptOffers () {
      var price = 0
      var priceType = ''
      var label = ''
      var i = 0
      i = this.offers.findIndex(x => x.id === parseInt(this.offer_id))
      label = this.offers[i].label
      if (parseInt(this.offer_type) === 1) {
        price = this.offers[i].price
        priceType = 'كاش'
      } else {
        price = this.offers[i].installment_price
        priceType = 'قسط'
      }
      this.arrReceiptOffers[this.arrReceiptOffers.length] = {}
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].id = this.arrReceiptOffers.length
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].label = label
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].rec_id = this.offers[i].id
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].type = 1
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].price = price
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].priceType = priceType
      this.arrReceiptOffers[this.arrReceiptOffers.length - 1].priceTypeID = this.offer_type
      this.fillReceiptItems()
    },
    // ========================================================
    changeMaintenanAction (id) {
      let i = this.maintenancRecords.map(record => record.id).indexOf(id)
      if (i > -1) {
        if (this.maintenancRecords[i].change_date === null) {
          this.maintenancRecords[i].action = !this.maintenancRecords[i].action
        }
      }
      this.fillReceiptItems()
    },
    // ======================================================
    addToArrReceiptItems () {
      var i = 0
      var price = 0
      var arr = this.offer.split('-')
      if (Array.isArray(arr) && arr[0].length) {
        for (i = 0; i < arr.length; i++) {
          if (Array.isArray(arr) && arr[0].length) {
            let y = this.items.findIndex(x => x.item_id === parseInt(arr[i]))
            if (y > -1) {
              console.log(this.items[y])
              if (parseInt(this.itemsPriceType) === 1) {
                price = this.items[y].price
                this.itemsPriceTypeStr = 'كاش'
              } else if (parseInt(this.itemsPriceType) === 2) {
                price = this.items[y].installment_price
                this.itemsPriceTypeStr = 'قسط'
              } else if (parseInt(this.itemsPriceType) === 3) {
                price = this.items[y].warranty_price
                this.itemsPriceTypeStr = 'مستعمل'
              } else if (parseInt(this.itemsPriceType) === 4) {
                price = 0
                this.itemsPriceTypeStr = 'ضمان'
              } else if (parseInt(this.itemsPriceType) === 5) {
                price = 0
                this.itemsPriceTypeStr = 'هدية'
              } else {
                price = 0
                this.itemsPriceTypeStr = 'عرض'
              }
              this.arrReceiptItems[this.arrReceiptItems.length] = {}
              this.arrReceiptItems[this.arrReceiptItems.length - 1].id = this.arrReceiptItems.length
              this.arrReceiptItems[this.arrReceiptItems.length - 1].type = 0
              this.arrReceiptItems[this.arrReceiptItems.length - 1].price = price
              this.arrReceiptItems[this.arrReceiptItems.length - 1].item = this.items[y].item
              this.arrReceiptItems[this.arrReceiptItems.length - 1].rec_id = this.items[y].id
              this.arrReceiptItems[this.arrReceiptItems.length - 1].item_id = this.items[y].item_id
              this.arrReceiptItems[this.arrReceiptItems.length - 1].price_type = this.itemsPriceType
              this.arrReceiptItems[this.arrReceiptItems.length - 1].price_type_str = this.itemsPriceTypeStr
              this.arrReceiptItems[this.arrReceiptItems.length - 1].priceType = this.itemsPriceTypeStr
              this.arrReceiptItems[this.arrReceiptItems.length - 1].priceTypeID = this.itemsPriceType
            }
          }
        }
      }
      this.fillReceiptItems()
    },
    // ======================================================
    offer_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.fillReceiptItems()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ========================================================
    fillReceiptItems () {
      var price1
      var price2
      var totalPrice = 0
      var i
      this.receiptItems = []
      // -----------------------------------------------------------
      for (i = 0; i < this.arrReceiptOffers.length; i++) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = this.arrReceiptOffers[i].label
        this.receiptItems[this.receiptItems.length - 1].rec_id = this.arrReceiptOffers[i].rec_id
        this.receiptItems[this.receiptItems.length - 1].type = this.arrReceiptOffers[i].type
        this.receiptItems[this.receiptItems.length - 1].price = this.arrReceiptOffers[i].price
        this.receiptItems[this.receiptItems.length - 1].priceType = this.arrReceiptOffers[i].priceType
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = this.arrReceiptOffers[i].priceTypeID
        totalPrice = totalPrice + this.arrReceiptOffers[i].price
      }
      // -----------------------------------------------------------
      for (i = 0; i < this.arrReceiptItems.length; i++) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = this.arrReceiptItems[i].item
        this.receiptItems[this.receiptItems.length - 1].rec_id = this.arrReceiptItems[i].rec_id
        this.receiptItems[this.receiptItems.length - 1].type = this.arrReceiptItems[i].type
        this.receiptItems[this.receiptItems.length - 1].price = this.arrReceiptItems[i].price
        this.receiptItems[this.receiptItems.length - 1].priceType = this.arrReceiptItems[i].priceType
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = this.arrReceiptItems[i].priceTypeID
        totalPrice = totalPrice + this.arrReceiptItems[i].price
      }
      // -----------------------------------------------------------
      for (let i = 0; i < this.maintenancRecords.length; i++) {
        if (this.maintenancRecords[i].action) {
          const str = 'تغيير '
          this.receiptItems[this.receiptItems.length] = {}
          this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
          this.receiptItems[this.receiptItems.length - 1].label = str + this.maintenancRecords[i].item
          this.receiptItems[this.receiptItems.length - 1].rec_id = this.maintenancRecords[i].item_id
          this.receiptItems[this.receiptItems.length - 1].type = 10
          this.receiptItems[this.receiptItems.length - 1].price = 0
          this.receiptItems[this.receiptItems.length - 1].priceType = ''
          this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        }
      }
      // -----------------------------------------------------------
      if (parseInt(this.record.balance) > 0) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'مديونية سابقة'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 2
        this.receiptItems[this.receiptItems.length - 1].price = parseInt(this.record.balance || 0)
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
      }
      // -----------------------------------------------------------
      if (parseInt(this.record.maintenance_expenses) > 0) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'مصاريف صيانة'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 3
        this.receiptItems[this.receiptItems.length - 1].price = parseInt(this.record.maintenance_expenses || 0)
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
      }
      if (this.record.type_id < 4) {
        // -----------------------------------------------------------
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'الاجمالى'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 4
        this.receiptItems[this.receiptItems.length - 1].price = parseInt(totalPrice || 0) + parseInt(this.record.balance || 0) + parseInt(this.record.maintenance_expenses || 0) + parseInt(price1 || 0) + parseInt(price2 || 0)
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        // -----------------------------------------------------------
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'المدفوع'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 5
        this.receiptItems[this.receiptItems.length - 1].price = parseInt(this.record.paid || 0)
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        // -----------------------------------------------------------
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'الباقى'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 6
        this.receiptItems[this.receiptItems.length - 1].price = (parseInt(totalPrice || 0) + parseInt(this.record.balance || 0) + parseInt(this.record.maintenance_expenses || 0) + parseInt(price1 || 0) + parseInt(price2 || 0)) - parseInt(this.record.paid || 0)
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
      }
      // -----------------------------------------------------------
      this.record.required = parseInt(totalPrice || 0) + parseInt(this.record.balance || 0) + parseInt(this.record.maintenance_expenses || 0) + parseInt(price1 || 0) + parseInt(price2 || 0)
      if (this.record.paid > 0) {
        this.record.amount_str = '-مبلغ وقدره ' + this.record.paid + 'ج ' + tafqeet(this.record.paid) + ' جنيهاً فقط لا غير-'
      } else {
        if (this.record.type_id < 4) {
          this.record.amount_str = 'لا شيئ'
        } else {
          this.record.amount_str = 'مبلغ وقدره'
        }
      }
      // -----------------------------------------------------------
      this.record.rest = (parseInt(totalPrice || 0) + parseInt(this.record.balance || 0) + parseInt(this.record.maintenance_expenses || 0) + parseInt(price1 || 0) + parseInt(price2 || 0)) - parseInt(this.record.paid || 0)
      if (this.record.type_id < 4) {
        if (this.record.rest > 0) {
          this.record.rest_str = 'والمبلغ المتبقى ' + this.record.rest + 'ج فقط ' + tafqeet(this.record.rest) + ' جنيهاً لا غير'
        } else {
          this.record.rest_str = 'المبلغ المتبقى: صفر (لا توجد اقساط مستحقة من ثمن العرض او الصيانة)'
        }
      } else {
        this.record.rest_str = this.record.notes
      }
    },
    // ========================================================
    mirrorNotes () {
      this.record.notes = this.record.callNotes
    },
    // ========================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ========================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // ========================================================
    getData (id, fromDate, toDate, type) {
      this.isContractOffersLoading = true
      this.noRecords = false
      axios.post(this.$apiURL + 'get-customer-data-receipt02', {
        token: localStorage.getItem('token'),
        id: id,
        type: type,
        offer_id: this.offer_id,
        branch_id: this.$store.state.customerData.branche_id,
        contract_offer_id: this.contract_offer_id,
        date_from: fromDate,
        isInLimit: this.isInLimit,
        date_to: toDate
      })
        .then(res => {
          if (res.data === 'No Records') {
            this.noRecords = true
          } else {
            this.isContractOffersLoading = false
            this.maintenancRecords = res.data.Maintenances
            this.record = res.data.Data
            this.fillReceiptItems()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    // ========================================================
    removeItem (rec) {
      if (rec.type === 0) {
        let i = this.arrReceiptItems.map(record => record.label).indexOf(rec.label)
        this.arrReceiptItems.splice(i, 1)
      }
      if (rec.type === 1) {
        let i = this.arrReceiptOffers.map(record => record.label).indexOf(rec.label)
        this.arrReceiptOffers.splice(i, 1)
      }
      this.fillReceiptItems()
    },
    // ========================================================
    saveData () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'create-cash-receipt02', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        offer_id: this.record.contract_offer_id,
        offer_type: this.price_type,
        amount: this.record.paid,
        amount_str: this.record.amount_str,
        maintenance_expenses: this.record.maintenance_expenses,
        caption: this.record.caption,
        date: this.date,
        delay: this.record.delay,
        rest: this.record.rest,
        rest_str: this.record.rest_str,
        type_id: this.record.type_id,
        receiptItems: this.receiptItems,
        maintenance_request: this.record.maintenance_request,
        maintenance_required: this.record.maintenance_required,
        notes: this.record.notes,
        call_status_id: this.record.call_status_id,
        call_action_id: this.record.call_action_id,
        call_type_id: this.record.type_id,
        callNotes: this.record.callNotes,
        call_delay: this.record.call_delay
      })
        .then(res => {
          this.callMethod(this.offer_id)
          this.isLoadingSave = false
          this.record.id = res.data.RecId
          this.errorShow = false
          this.success = 'تم إصدار الايصال رقم #' + res.data + '# بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    // ===================================================
    offerRejected () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'offer-rejected', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        customer_id: this.$store.state.customerData.id,
        contract_id: this.record.contract_id,
        offer_id: this.offer_id,
        call_status_id: this.record.call_status_id,
        call_action_id: this.record.call_action_id,
        call_type_id: this.record.call_type_id,
        callNotes: this.record.callNotes,
        call_delay: this.record.call_delay
      })
        .then(res => {
          this.callMethod(this.offer_id)
          this.isLoadingSave = false
          this.errorShow = false
          this.success = 'تم حفظ الرفض بنجاح !!'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateDailyReceipts02.vue